import NavigationController from '../base/-base-navigation-controller';

export default class MaintenanceController extends NavigationController {
  queryParams = ['fromBreadcrumb'];
}
